import { Component } from '@angular/core';
import {
  BannerIconComponent,
  BannerIconDetails
} from '../banner-icon/banner-icon.component';
import { NgFor } from '@angular/common';
import { FloatingButtonComponent } from '../floating-button/floating-button.component';

@Component({
  selector: 'app-ifr-vfr-mastery-banner',
  styleUrls: ['ifr-vfr-mastery-banner.component.scss'],
  templateUrl: 'ifr-vfr-mastery-banner.component.html',
  standalone: true,
  imports: [BannerIconComponent, NgFor, FloatingButtonComponent]
})
export class IfrVfrMasteryBannerComponent {
  backgroundImageUrl = 'assets/backgrounds/PilotWorkshops.jpg';
  title = 'VFR & IFR MASTERY';
  subTitle =
    'VFR and IFR Mastery are a continuing series of online, scenario-based workshops. Each month we provide a challenging, real-world scenario that will test your knowledge and hone your decision making skills.';
  icons: BannerIconDetails[] = [
    {
      iconPath: 'assets/images/video.png',
      title: 'Watch',
      description: 'Start by watching a short briefing video'
    },
    {
      iconPath: 'assets/images/thinking.png',
      title: 'Think',
      description: 'Review several options to help decide'
    },
    {
      iconPath: 'assets/images/choice.png',
      title: 'Choose',
      description: 'Choose and compare your choice on a live poll'
    },
    {
      iconPath: 'assets/images/online-learning.png',
      title: 'Learn',
      description: `Watch the instructor's video and see their choice`
    },
    {
      iconPath: 'assets/images/mic.png',
      title: 'Listen',
      description: 'Roundtable discussion with flight instructors'
    },
    {
      iconPath: 'assets/images/conversation.png',
      title: 'Discuss',
      description: 'Visit the members-only online discussion forum'
    }
  ];
}
